var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGalleryGreen = function SvgGalleryGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "31px",
    viewBox: "0 0 34 31",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "collections_black_24dp")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-12-Pro",
    transform: "translate(-224.000000, -793.000000)",
    fill: "#48BB62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "collections_black_24dp",
    transform: "translate(241.022001, 808.779453) rotate(10.000000) translate(-241.022001, -808.779453) translate(226.438668, 796.279453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.169716536,8.59523122 C1.351225,11.8413991 3.1234877,16.7106508 5.48650464,23.2029865 C5.97637724,24.5489004 7.47838438,25.2492978 8.82429829,24.7594252 C11.9350823,23.6271924 13.9518816,22.8931375 14.8746964,22.5572604 C14.9103695,22.5442765 10.6776982,22.5602782 10.6776982,22.5602782 C9.85508271,22.5834595 9.22555933,22.3970101 8.78912805,22.0009299 L7.93362084,22.312309 L2.595826,7.64683824 L6.6938491,6.15527982 L6.69262395,3.36492097 C4.44721536,4.18218286 2.78263359,4.78804107 1.69887864,5.18249562 C0.475320541,5.62783435 -0.136268163,7.75454517 0.169716536,8.59523122 Z M26.3020836,3.125 L26.3020836,18.75 L10.6770836,18.75 L10.6770836,3.125 L26.3020836,3.125 M26.3020836,0.520833333 L10.6770836,0.520833333 C9.24479193,0.520833333 8.07291693,1.69270833 8.07291693,3.125 L8.07291693,18.75 C8.07291693,20.1822917 9.24479193,21.3541667 10.6770836,21.3541667 L26.3020836,21.3541667 C27.7343753,21.3541667 28.9062503,20.1822917 28.9062503,18.75 L28.9062503,3.125 C28.9062503,1.69270833 27.7343753,0.520833333 26.3020836,0.520833333 Z M15.2343753,13.1119792 L17.4348961,16.0546875 L20.6640628,12.0182292 L25.0000003,17.4479167 L11.9791669,17.4479167 L15.2343753,13.1119792 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14.7746762,
    cy: 8.65834559,
    r: 1.30208333
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGalleryGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gallery_green.1ee9778b.svg";
export { ForwardRef as ReactComponent };